import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckBranchConfigIds } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CONFIG_IDS } from '@constants/queryKeys';

const useQueryConsistencyCheckConfigIds = (comparisonId: string) => {
	const {
		data: configIdsOptions,
		isLoading,
		isFetching,
	} = useQuery<string[], TSelectOption[]>({
		queryKey: [CONSISTENCY_CONFIG_IDS, comparisonId],
		queryFn: extractQueryParams(getConsistencyCheckBranchConfigIds),
		select: (options) => fieldsOptionsFormatted(options.filter(option => option !== null) || []),
		enabled: [comparisonId],
		...refetchOptions,
	});

	return {
		configIdsOptions: configIdsOptions || [],
		isLoadingSiteIdsOptions: (isLoading && !!configIdsOptions)
			|| isFetching,
	};
};

export default useQueryConsistencyCheckConfigIds;
